import dayjs from "dayjs";
import { clearQuery } from "../store/reducers/query";
import { clearAdvanceSearch } from "../store/reducers/queryData";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import {
  AccessTimeOutlined,
  CancelOutlined,
  SendOutlined,
  TaskAltOutlined,
} from "@mui/icons-material";

export const formatDate = (date) => {
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.format("DD/MM/YYYY") : date;
};
export const formatTime = (date) => {
  return dayjs(date).format("hh:mm A");
};

export const closeQuery = (dispatch) => {
  dispatch(clearQuery());
  dispatch(clearAdvanceSearch());
};

export const downloadFile = (url) => {
  saveAs(url);
};

export const teamUsers = (teams = [], users = []) => {
  return users.filter((user) => {
    let InTeam = false;
    teams.forEach((team) => {
      if (team.srManager?._id === user._id) {
        InTeam = true;
        return true;
      } else if (team.manager?._id === user._id) {
        InTeam = true;
        return true;
      } else if (team.assistantManager?._id === user._id) {
        InTeam = true;
        return true;
      } else if (team.teamLead?._id === user._id) {
        InTeam = true;
        return true;
      } else if (team.agents && team.agents.length > 0) {
        team.agents.forEach((agent) => {
          if (agent._id === user._id) {
            InTeam = true;
            return true;
          }
        });
      }
    });

    if (InTeam) {
      return true;
    }
    return false;
  });
};

export const checkInTeam = (teams = [], user) => {
  let InTeam = false;
  const team = teams.filter((team) => {
    if (team.srManager?._id === user?._id) {
      InTeam = true;
      return true;
    } else if (team.manager?._id === user?._id) {
      InTeam = true;
      return true;
    } else if (team.assistantManager?._id === user?._id) {
      InTeam = true;
      return true;
    } else if (team.teamLead?._id === user?._id) {
      InTeam = true;
      return true;
    } else if (team.agents && team.agents?.length > 0) {
      team.agents?.forEach((ag) => {
        if (ag._id === user?._id) {
          InTeam = true;
          return true;
        }
      });
    }

    if (InTeam) {
      return true;
    }
    return false;
  });

  return team[0] || {};
};

export const jsonSort = (array = [], key, ascending = false) => {
  if (array) {
    return array.sort((a, b) => {
      const compareValue = ascending ? -1 : 1;

      if (a[key] < b[key]) {
        return compareValue;
      }
      if (a[key] > b[key]) {
        return -compareValue;
      }
      return 0;
    });
  }

  return [];
};

export const filterArr = (arr = [], key, value) => {
  console.log(key, value);
  return arr.filter((item) => {
    return item[key] === value;
  });
};

export const getAddressFromCoordinates = async (coordinates, key) => {
  const { lat, lng } = coordinates;
  try {
    if (!!lat) {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${key}`
      );
      const json = await response.json();
      // setRealAddress(json.results[0]?.formatted_address);
      return json?.results[0]?.formatted_address;
    }
  } catch (error) {
    console.error("errLocation", error);
  }
};

export const customExcelDownload = (
  data,
  merges = [],
  fileName = "download"
) => {
  
  const ws = XLSX.utils.json_to_sheet(data);

  // Apply merges
  ws["!merges"] = merges;

  // Auto width
  const colWidths = Object.keys(data[0] || {}).map((key) => ({
    wch: Math.max(
      key.length,
      ...data.map((row) => String(row[key] ?? "").length)
    ) + 2,
  }));

  ws["!cols"] = colWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Report");

  XLSX.writeFile(wb, `${fileName}.xlsx`);
};

export const customCsvDownload = (data,fileName="download") => {
  const ws = XLSX.utils.json_to_sheet(data);
  const csvData = XLSX.utils.sheet_to_csv(ws);
  const blob = new Blob([csvData], { type: "text/csv" });

  // Create download link
  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = `${fileName}.csv`;

  // Append the link to the body
  document.body.appendChild(downloadLink);

  // Trigger the download
  downloadLink.click();

  // Remove the link from the DOM
  document.body.removeChild(downloadLink);
};

export const updateSearchParams = (setSearchParams, updates) => {
  setSearchParams((prevParams) => {
    const params = new URLSearchParams(prevParams);
    Object.entries(updates).forEach(([key, value]) => {
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    return params;
  });
};

export const safeArrayData = (data) => (Array.isArray(data) ? data : []);

export const formatCurrency = (value) => {
  if (!value) return 0;

  return value.toLocaleString("en-AE", {
    notation: "compact",
    compactDisplay: "short",
  });
};

export function formatShortNumber(num) {
  if (num === null || num === undefined || isNaN(num)) return "0";

  const absNum = Math.abs(num);
  const units = [
    { value: 1e30, symbol: "N" }, // Nonillion
    { value: 1e27, symbol: "Oc" }, // Octillion
    { value: 1e24, symbol: "Sp" }, // Septillion
    { value: 1e21, symbol: "Sx" }, // Sextillion
    { value: 1e18, symbol: "Qi" }, // Quintillion
    { value: 1e15, symbol: "Qa" }, // Quadrillion
    { value: 1e12, symbol: "T" }, // Trillion
    { value: 1e9, symbol: "B" }, // Billion
    { value: 1e6, symbol: "M" }, // Million
    { value: 1e3, symbol: "K" }, // Thousand
  ];

  for (let i = 0; i < units.length; i++) {
    if (absNum >= units[i].value) {
      return (
        (num / units[i].value).toFixed(1).replace(/\.0$/, "") + units[i].symbol
      );
    }
  }

  return num.toString();
}

export function getFirstName(name = "") {
  return name.split(" ")[0];
}

export function createParams(prevParams, updates) {
  const params = new URLSearchParams(prevParams);
  Object.entries(updates).forEach(([key, value]) => {
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
  });
  return params.toString();
}

export function calculateBookingPercentage(commission, total) {
  const commissionValue = parseFloat(commission);
  const totalValue = parseFloat(total);

  if (isNaN(commissionValue) || isNaN(totalValue) || totalValue === 0) {
    return 0;
  }

  const commissionPercentage = (commissionValue / totalValue) * 100;
  return commissionPercentage.toFixed(2);
}

export function calculateBookingValues(commissionPerc, total) {
  const commissionPercentage = parseFloat(commissionPerc);
  const totalValue = parseFloat(total);

  if (isNaN(commissionPercentage) || isNaN(totalValue)) {
    return 0;
  }

  const commission = (commissionPercentage / 100) * totalValue;
  return commission.toFixed(2);
}

export function calculateNetCommission(
  commission,
  clientLoyalty,
  brokerReferral
) {
  const commissionValue = parseFloat(commission);
  const clientLoyaltyValue = parseFloat(clientLoyalty);
  const brokerReferralValue = parseFloat(brokerReferral);

  if (
    isNaN(commissionValue) ||
    isNaN(clientLoyaltyValue) ||
    isNaN(brokerReferralValue)
  ) {
    return 0;
  }

  return (commissionValue - (clientLoyaltyValue + brokerReferralValue)).toFixed(
    2
  );
}

export const checkPermission = (perm, module, task, userRole) => {
  if (userRole === "agent" && module === "HrmsDashboard") return false;
  return userRole === "sup_admin" || userRole === "developer" || perm[module]?.[task]?.value === true;
};

export function getErrorMessage(error) {
  try {
    const data = error?.response?.data;

    if (!data) return "Something went wrong";

    if (typeof data === "string") return data;

    if (data.message) return data.message;
    if (data.error) return data.error;

    return JSON.stringify(data);
  } catch {
    return "Unknown error";
  }
}

export const invitationStats = [
  {
    label: "Total Invitations",
    key: "Total",
    Icon: SendOutlined,
    color: "#2563EB",
  },
  {
    label: "Accepted Invitations",
    key: "Accepted",
    Icon: TaskAltOutlined,
    color: "#16A34A",
  },
  {
    label: "Declined Invitations",
    key: "Declined",
    Icon: CancelOutlined,
    color: "#DC2626",
  },
  {
    label: "Pending Invitations",
    key: "Pending",
    Icon: AccessTimeOutlined,
    color: "#CA8A04",
  },
];
